module.exports = __webpack_public_path__ + "static/img/Yilan_01.e4b7f568.jpg";